import React from "react";
import { View, Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const { width: screenWidth } = Dimensions.get("window");

const UserDetailSkeleton: React.FC = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View style={{}}>
      <View
        style={{
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "100%"
              : 347,
          padding: 8,
          borderColor: AppColors.gray_828282,
          borderWidth: 0.8,
          borderRadius: 8,
          backgroundColor: AppColors.black_191919,
          gap: 12,
        }}
      >
        {/* Avatar and Real Image Row */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignSelf: "stretch",
          }}
        >
          <Skeletons
            width="96px"
            height="96px"
            style={{ borderRadius: 65 }}
          />
          <Skeletons
            width="96px"
            height="96px"
            style={{ borderRadius: 65 }}
          />
        </View>

        {/* Username */}
        <Skeletons width="150px" height={28} style={{ borderRadius: 4 }} />

        {/* Bio Section */}
        <View
          style={{
            borderRadius: 4,
            backgroundColor: "#121212",
            padding: 4,
            alignSelf: "stretch",
            marginTop: 1,
          }}
        >
          <Skeletons width="100%" height={55} style={{ borderRadius: 4 }} />
        </View>

        <Skeletons
          width="100%"
          height={1}
          style={{ borderRadius: 4 }}
        />

        {/* Social Links */}
        <View
          style={{
            paddingHorizontal: 10,
            paddingVertical: 4,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 16,
              alignItems: "center",
            }}
          >
            {Array(4)
              .fill(null)
              .map((_, index) => (
                <View key={index} style={{ gap: 8, alignItems: "center" }}>
                  <Skeletons
                    width="36px"
                    height="36px"
                    style={{ borderRadius: 4 }}
                  />
                  <Skeletons
                    width="60px"
                    height={12}
                    style={{ borderRadius: 4 }}
                  />
                </View>
              ))}
          </View>
        </View>

        {/* Add Social Link Button */}
        <Skeletons
          width="110px"
          height={12}
          style={{ borderRadius: 4, alignSelf: "flex-end", marginTop: 4 }}
        />
      </View>
    </View>
  );
};

export default UserDetailSkeleton;

const useStyles = CreateResponsiveStyle(
  {
    searchTextStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderWidth: 0,
      borderRadius: 10,
      padding: 12,
      verticalAlign: "top",
      width: 289,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      searchTextStyle: { width: "100%" },
    },
    [DEVICE_SIZES.XS]: {
      searchTextStyle: { width: "100%" },
    },
  }
);
